import { graphql } from '../../gql';

export const REFERENCE_LISTS_QUERY = graphql(`
  query ReferenceLists {
    highestDegree {
      id
      name
    }
    ethnicity {
      id
      name
    }
    gender {
      id
      name
    }
    seniority {
      id
      name
    }
    employmentRelationship {
      id
      name
    }
    workSchedule {
      id
      name
    }
    remoteType {
      id
      name
    }
  }
`);
